/*============================================================================
  Table of Contents:
    *Global
    *Cookies
    *Product Page
    *Filtering
==============================================================================*/

// if (window.location.hash == "#no-crop"){
  
//   console.log("t")

//   $(".shopify-section .hero, .shopify-section .hero .slick-track,.slideshow-madoo-homepage-slideshow").css("height","100%!important")
  
// }


//*****************GLOBAL*****************

$(".main-content").css({
  "margin-top": $("header").outerHeight()
});

$(".page-container,#shopify-section-collection-template").css({
  "min-height":$(window).height() - $("header").outerHeight()
});

$(".page-container,.site-footer").addClass("a");

$(".center").css({
  "min-height":$(window).height(),
  "top": - $("header").outerHeight()
});

//*****************COOKIES*****************

 function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    }
    else
    {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
        end = dc.length;
        }
    }
    return decodeURI(dc.substring(begin + prefix.length, end));
} 

function cookie() {

    var staff = getCookie("loggedin");
    var myCookie = getCookie("PolicyAccepted");
    
    if (myCookie == null) {
    	$(".policy-bar").show();
    }
}

cookie();

// Policy Bar
$(".policy-bar .btn").on("click",function(){
    $.cookie('PolicyAccepted',1);
  $(".policy-bar").hide();
});


function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function checkCookie() {
  var user = getCookie("username");
  if (user != "") {

    $("#shadow,.shadow").show()

     $("#previewtext,.drawer-newsletter").hide();
    
  } else {
  }
}


checkCookie();


//*****************PRODUCT PAGE*****************

  var header = $("header").outerHeight();
  var end = $(".product__photos").outerHeight() -  $(".product__details").outerHeight();


  $(window).on("resize",function(){

    end = $(".product__photos").outerHeight() - $(".product__details").outerHeight();

    if( $(window).width() < 1250 ) {

      $(".product__details").css({
          "position":"relative",
          "top":"0"
      });

      $(window).unbind( "scroll" );

    }else{
      scroll();
    }

  });

  $("img").on("load",function(){
    
    end = $(".product__photos").outerHeight() - $(".product__details").outerHeight();

  });



  if( $(window).width() > 1250 ) {
  
    scroll();

  }

  function scroll(){
    $(window).on("scroll",function(){

      if($(window).scrollTop() < end ){
  
        $(".product__details").css({
          "position":"fixed",
          "top":header,
          "left":"0",
          "bottom":"auto"
        });
  
      }else{

        if(end > 0){
  
        $(".product__details").css({
          "position":"absolute",
          "top":"auto",
          "bottom":"0",
          "left":"0"
        });

        }
  
      }
  
    });
  }


$(".share").on("click",function(){

  $(this).hide();
  $(this).siblings().show();

});

var swiperZoom = new Swiper('.swiper-container-zoom', {
  zoom: {
    maxRatio: 2,
    toggle: true
  },
  speed: 0,
  keyboard: true,
  on: {
    slideChangeTransitionEnd: function () {
      swiperZoom.zoom.in();
    },
  }
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },
});

$(".product__photo.grid__item.medium-up--one-whole").on("click",function(){

  $(".swiper-container-zoom").css("visibility","visible");
  swiperZoom.slideTo($(this).index());

});

$(".swiper-container-zoom .close").on("click",function(){

  $(".swiper-container-zoom").css("visibility","hidden");

});


//*****************FILTERING*****************

// function arr_diff (a1, a2) {

//     var a = [], diff = [];

//     for (var i = 0; i < a1.length; i++) {
//         a[a1[i]] = true;
//     }

//     for (var i = 0; i < a2.length; i++) {
//         if (a[a2[i]]) {
//             delete a[a2[i]];
//         } else {
//             a[a2[i]] = true;
//         }
//     }

//     for (var k in a) {
//         diff.push(k);
//     }

//     return diff;
// }

// function filterPrice(){


//   var filters = $(".filters").find("li.a");
//   var filtersActive = [];

//   $(filters).each(function(){
//     filtersActive.push($(this).attr("data-filter"));
//   });


//   $(".product-item").hide();

//   if(filtersActive.length == 1){

//     $(".product-item").each(function(){



//             var price = $(this).attr("data-price");

//             if($(".price li.a").length > 0){

//               if($(".price li.a").index() == 0){

//                 if(price < 100000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 1){

//                 if(price > 100000 && price < 150000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 2){

//                 if(price > 150000 && price < 500000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 3){

//                 if(price > 500000 && price < 1500000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 4){

//                 if(price > 1500000 && price < 2500000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 5){

//                 if(price > 2500000){
//                   $(this).show();
//                 }  

//               }

//             }else{

//               $(this).show();

//             }




//        });


//   }else{

//     $(filtersActive).each(function(i,v){

//        $(".product-item").each(function(){


//          if ($(this).attr("data-filters").indexOf(v) > -1) {

//             var price = $(this).attr("data-price");

//             if($(".price li.a").length > 0){

//               if($(".price li.a").index() == 0){

//                 if(price < 100000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 1){

//                 if(price > 100000 && price < 150000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 2){

//                 if(price > 150000 && price < 500000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 3){

//                 if(price > 500000 && price < 1500000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 4){

//                 if(price > 1500000 && price < 2500000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 5){

//                 if(price > 2500000){
//                   $(this).show();
//                 }  

//               }

//             }else{

//               $(this).show();

//             }


//           }


//        });
  

//     });

//   }

// }


// $(".price li").on("click",function(){


//    $(".price li").removeClass("a");
  
//   if($(this).hasClass("a")){

//     $(this).removeClass("a");
//     localStorage.setItem($(this).text(), 0);

//   }else{

//     $(this).addClass("a");
//     localStorage.setItem($(this).text(), 1);

//   }
  
//     filterPrice()

// });



// $(".filter li").each(function(){

//     if (localStorage.getItem($(this).text()) == 1) {
      
//       $(this).addClass("a");
//       filter();

//       $(".filter-drawer").slideDown();
//       $(".collapse").show();

//     }

// });


// $(".price li").each(function(){

//     if (localStorage.getItem($(this).text()) == 1) {
      
//       $(this).addClass("a");
//       filterPrice()


//       $(".filter-drawer").slideDown();
//       $(".collapse").show();

//     }

// });



// function filter(){
//   var filter = $(this).attr("data-filter")

//   var filters = $(".filters").find("li.a");
//   var filtersActive = [];

//   $(filters).each(function(){
//     filtersActive.push($(this).attr("data-filter"));
//   });


//   $(".product-item").hide();

//     $(filtersActive).each(function(i,v){

//        $(".product-item").each(function(){
//          if ($(this).attr("data-filters").indexOf(v) > -1) {

//             var price = $(this).attr("data-price");

//             if($(".price li.a").length > 0){

//               if($(".price li.a").index() == 0){

//                 if(price < 100000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 1){

//                 if(price > 100000 && price < 150000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 2){

//                 if(price > 150000 && price < 500000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 3){

//                 if(price > 500000 && price < 1500000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 4){

//                 if(price > 1500000 && price < 2500000){
//                   $(this).show();
//                 }  

//               }

//               if($(".price li.a").index() == 5){

//                 if(price > 2500000){
//                   $(this).show();
//                 }  

//               }

//             }else{

//               $(this).show();

//             }

//           }

//        });
  
//     });
// }

// var firstClick = 0;

// $(".filter li").on("click",function(){

  
//   if($(this).hasClass("a")){

//     $(this).removeClass("a");
//     localStorage.setItem($(this).text(), 0);

//   }else{

//     $(this).addClass("a");
//     localStorage.setItem($(this).text(), 1);

//   }

//   filter();

// });

// Sort

$(".sort li").on("click",function(){

//   $(".sort li").removeClass("a");
//   $(this).addClass("a");
  
  if($(this).hasClass("a")){

    $(this).removeClass("a");
    localStorage.setItem($(this).text(), 0);

  }else{

    $(this).addClass("a");
    localStorage.setItem($(this).text(), 1);

  }

  var sortBy = $(this).attr("data-value");
  if(sortBy == "artist"){
    sortListArtist();
  }
  if(sortBy == "gallery"){
    sortListLetter();
  }

  if(sortBy == "price"){
    sortListInteger();
  }

  if(sortBy == "price-down"){
    sortListPriceDown();
  }

  $("html,body").scrollTop(0);

});

function sortListArtist(field) {
  var list, i, switching, b, shouldSwitch;
  list = document.getElementById("sort-container");
  switching = true;
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // Start by saying: no switching is done:
    switching = false;
    b = $(".product-item")
    // Loop through all list items:
    for (i = 0; i < (b.length - 1); i++) {
      // Start by saying there should be no switching:
      shouldSwitch = false;
      /* Check if the next item should
      switch place with the current item: */
      if (b[i].dataset.artist.toLowerCase() > b[i + 1].dataset.artist.toLowerCase()) {
        /* If next item is alphabetically lower than current item,
        mark as a switch and break the loop: */
        shouldSwitch = true;
        break;
      }
    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark the switch as done: */
      b[i].parentNode.insertBefore(b[i + 1], b[i]);
      switching = true;
    }
  }
}

function sortListLetter(field) {
  var list, i, switching, b, shouldSwitch;
  list = document.getElementById("sort-container");
  switching = true;
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // Start by saying: no switching is done:
    switching = false;
    b = $(".product-item")
    // Loop through all list items:
    for (i = 0; i < (b.length - 1); i++) {
      // Start by saying there should be no switching:
      shouldSwitch = false;
      /* Check if the next item should
      switch place with the current item: */
      if (b[i].dataset.gallery.toLowerCase() > b[i + 1].dataset.gallery.toLowerCase()) {
        /* If next item is alphabetically lower than current item,
        mark as a switch and break the loop: */
        shouldSwitch = true;
        break;
      }
    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark the switch as done: */
      b[i].parentNode.insertBefore(b[i + 1], b[i]);
      switching = true;
    }
  }
}

function sortListInteger(field) {
  var list, i, switching, b, shouldSwitch;
  list = document.getElementById("sort-container");
  switching = true;
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // Start by saying: no switching is done:
    switching = false;
    b = $(".product-item")
    // Loop through all list items:
    for (i = 0; i < (b.length - 1); i++) {
      // Start by saying there should be no switching:
      shouldSwitch = false;
      /* Check if the next item should
      switch place with the current item: */
      if (parseInt(b[i].dataset.price.toLowerCase()) > parseInt(b[i + 1].dataset.price.toLowerCase())) {
        /* If next item is alphabetically lower than current item,
        mark as a switch and break the loop: */
        shouldSwitch = true;
        break;
      }
    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark the switch as done: */
      b[i].parentNode.insertBefore(b[i + 1], b[i]);
      switching = true;
    }
  }
}

function sortListPriceDown(field) {
  var list, i, switching, b, shouldSwitch;
  list = document.getElementById("sort-container");
  switching = true;
  /* Make a loop that will continue until
  no switching has been done: */
  while (switching) {
    // Start by saying: no switching is done:
    switching = false;
    b = $(".product-item")
    // Loop through all list items:
    for (i = 0; i < (b.length - 1); i++) {
      // Start by saying there should be no switching:
      shouldSwitch = false;
      /* Check if the next item should
      switch place with the current item: */
      if (parseInt(b[i].dataset.price.toLowerCase()) < parseInt(b[i + 1].dataset.price.toLowerCase())) {
        /* If next item is alphabetically lower than current item,
        mark as a switch and break the loop: */
        shouldSwitch = true;
        break;
      }
    }
    if (shouldSwitch) {
      /* If a switch has been marked, make the switch
      and mark the switch as done: */
      b[i].parentNode.insertBefore(b[i + 1], b[i]);
      switching = true;
    }
  }
}





// $(".set li").on("click",function(){

//   if($(".filters").find("li.a").length < 1){
//     $(".product-item").show();

//   }
// });

// $(".clearFilters").on("click",function(){

//   $(".filters li").removeClass("a");
//   $(".product-item").show();

//   $(".filter li,.sort li,.price li").each(function(){

//    localStorage.setItem($(this).text(), 0);

//   });

// });

$(".filter-toggle").on("click",function(){

  $(".filter-drawer").slideDown();
  $(".collapse").show();

});

$(".collapse").on("click",function(){

  $(".filter-drawer").slideUp();
  $(".collapse").hide();

});



//*****************VISIT PAGE*****************


